<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add to Roster</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0">

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="alert alert-danger mb-3" role="alert"
         *ngIf="ageBlockedOwnerCustomer">
      This customer is too young to own this membership.
      They must be at least {{ orgService.getOrganizationConfig().membership_minimum_age }} years old.
      Please link this customer to an account of sufficient age and make the purchase from that account.
      <a [routerLink]="['/customers', ageBlockedOwnerCustomer.id.toString()]" target="_blank">
        View {{ ageBlockedOwnerCustomer.first_name }} {{ ageBlockedOwnerCustomer.last_name }}'s profile
      </a>
    </div>

    <p>
      <b>{{ eventTypeName }}</b>
    </p>

    <hr>

    <div class="form-group">
      <label for="selectedRoster">Roster</label>
      <select class="custom-select"
              id="selectedRoster"
              name="selectedRoster"
              *ngIf="!loadingRosters"
              [disabled]="hasFixedRoster || loadingSubmit"
              [class.disabled]="hasFixedRoster || loadingSubmit"
              [(ngModel)]="selectedRoster">
        <option [ngValue]="null" disabled>
          - Select a Roster -
        </option>
        <option *ngFor="let roster of rosters"
                [ngValue]="roster">
          {{ roster.name }}
        </option>
      </select>
      <select class="custom-select disabled" disabled
              *ngIf="loadingRosters">
        <option>
          Loading...
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="searchCustomersInput">
        Roster Membership Owner
        <ng-container *ngIf="!hasFixedParticipantCustomer">
          (optional)
        </ng-container>
      </label>
      <input type="text" class="form-control" id="searchCustomersInput"
             placeholder="Search by email, name, barcode, or telephone"
             [disabled]="hasFixedOwnerCustomer"
             [class.disabled]="hasFixedOwnerCustomer"
             [(ngModel)]="search"
             (ngModelChange)="handleCustomerFilterChange()">
    </div>

    <!-- Add a fixed-height div to prevent the input from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
         *ngIf="(selectedOwnerCustomer === null) && hasSearchInput() && !hasFixedOwnerCustomer">

      <ng-container *ngIf="hasSearchInput()">

        <table class="table table-bordered table-hover">
          <tbody *ngIf="!customerResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingOwnerCustomers ? 'Loading...' : 'No results' }}
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="customerResultsPresent()">
            <tr style="cursor:pointer"
                *ngFor="let customer of customerList"
                (click)="selectCustomer(customer)">
              <td>
                {{ customer.first_name }} {{ customer.last_name }}
                <span class="text-muted">
                  {{ dateStringFromISO8601(customer.birthday )}}
                  <span *ngIf="customer.email">- {{ customer.email }}</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="alert alert-info" *ngIf="!loadingOwnerCustomers && hasRecentActivityFilter()">
          Only recently-active customers are being shown.
          <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
            Expand search to all customers.
          </a>
        </div>

      </ng-container>

    </div>

    <small class="form-text text-muted mb-3" style="margin-top: -0.5rem">
      The roster membership owner is the account with pays for and manages the roster membership. They are not necessarily the same person as the participant.
      <ng-container *ngIf="!hasFixedParticipantCustomer">
        The participant will be chosen at the next step.
      </ng-container>
    </small>

    <div class="form-group" *ngIf="hasFixedParticipantCustomer">
      <label>
        Roster Participant
      </label>
      <input type="text" class="form-control disabled" disabled
             *ngIf="selectedParticipantCustomer"
             [value]="selectedParticipantCustomer.first_name + ' ' + selectedParticipantCustomer.last_name">
      <input type="text" class="form-control disabled" disabled
             *ngIf="!selectedParticipantCustomer"
             value="Loading...">
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            *ngIf="!loadingSubmit"
            [disabled]="!submitButtonAvailable()"
            [class.disabled]="!submitButtonAvailable()"
            (click)="$event.preventDefault();handleSubmit();">
      Purchase Roster Membership
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
